import React from 'react';
import { Check } from 'iconoir-react';

export function IconoirCheckboxControl({
  checked,
  onChange,
  size = 'sm',
  disabled = false,
}: {
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  size?: 'sm' | 'md';
  disabled?: boolean;
}) {
  const box = size === 'md' ? 'h-5 w-5' : 'h-4 w-4';
  const icon = size === 'md' ? 'h-3.5 w-3.5' : 'h-3 w-3';
  return (
    <>
      <input
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span
        className={`${box} shrink-0 flex items-center justify-center rounded border-2 transition-colors peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-[#1066CB]/20 peer-focus-visible:ring-offset-0 ${
          disabled ? 'opacity-50 cursor-not-allowed ' : ''
        } ${checked ? 'border-[#6ECFCF] bg-[#6ECFCF]' : 'border-[#E2E8F0] bg-white'}`}
        aria-hidden
      >
        <Check
          className={`${icon} stroke-[#131315] text-[#131315] transition-opacity ${checked ? 'opacity-100' : 'opacity-0'}`}
          strokeWidth={2.5}
        />
      </span>
    </>
  );
}
